<template>
    <Title />
  
    <div class="container">
      <div class="text-muted px-10 mt-4 mb-4 text-center">30.07.2024 - prezent</div>
  
      <div
        class="card mb-4 text-center shadow-sm"
        v-for="(item, index) in paginatedItems"
        :key="index"
      >
        <a class="btn blue-btn" :href="item.link" target="_blank">
          {{ item.title }}
        </a>
      </div>
  
      <!-- Paginare frumoasă -->
      <div class="d-flex justify-content-center align-items-center gap-3 mt-5 mb-5">
        <button
          class="btn blue-btn d-flex align-items-center gap-1"
          @click="prevPage"
          :disabled="currentPage === 1"
        >
          <span class="bi bi-arrow-left"></span> Anterior
        </button>
  
        <span>Pagina {{ currentPage }}/{{ totalPages }}</span>
  
        <button
          class="btn blue-btn d-flex align-items-center gap-1"
          @click="nextPage"
          :disabled="currentPage === totalPages"
        >
          Următor <span class="bi bi-arrow-right"></span>
        </button>
      </div>
    </div>
  </template>
  
  <style scoped lang="scss">
  .responsive {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 700px;
    height: 300px;
  }
  
  @media only screen and (max-width: 950px) {
    .responsive {
      width: 100%;
      height: auto;
    }
  }
  </style>
  
  <script>
  import axios from 'axios'
  import Title from '../../components/Title.vue'
  
  export default {
    name: 'pcsb',
    data() {
      return {
        items: [],
        currentPage: 1,
        perPage: 20
      }
    },
    components: {
      Title
    },
    computed: {
      orderedItems() {
        return this.items.slice().sort((a, b) => b.id - a.id)
      },
      paginatedItems() {
        const start = (this.currentPage - 1) * this.perPage
        const end = start + this.perPage
        return this.orderedItems.slice(start, end)
      },
      totalPages() {
        return Math.ceil(this.items.length / this.perPage)
      }
    },
    methods: {
      nextPage() {
        if (this.currentPage < this.totalPages) {
          this.currentPage++
          this.scrollToTop()
        }
      },
      prevPage() {
        if (this.currentPage > 1) {
          this.currentPage--
          this.scrollToTop()
        }
      },
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    },
    mounted() {
      axios
        .get('https://www.executori.ro/api/public/static/json/pcsb.json')
        .then(response => {
          this.items = response.data
        })
        .catch(error => {
          console.log(error)
          this.errored = true
        })
        .finally(() => (this.loading = false))
    }
  }
  </script>
  